function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"),
    $(".map-section__container").remove(),
    $(".map-section__link").remove(),
    $(".map-section__overlay").after(
      '<div class="errors text-center">' + theme.strings.authError + "</div>"
    );
}
var customIFlag = 0;
(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (e, t) {
      var i = $(e),
        s = i.attr("data-section-id"),
        n = i.attr("data-section-type");
      if (((t = t || this.constructors[n]), !_.isUndefined(t))) {
        var a = _.assignIn(new t(e), { id: s, type: n, container: e });
        this.instances.push(a);
      }
    },
    _onSectionLoad: function (e) {
      var t = $("[data-section-id]", e.target)[0];
      t && this._createInstance(t);
    },
    _onSectionUnload: function (e) {
      this.instances = _.filter(this.instances, function (t) {
        var i = t.id === e.detail.sectionId;
        return i && _.isFunction(t.onUnload) && t.onUnload(e), !i;
      });
    },
    _onSelect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e);
    },
    _onDeselect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e);
    },
    _onBlockSelect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
    },
    _onBlockDeselect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) &&
        _.isFunction(t.onBlockDeselect) &&
        t.onBlockDeselect(e);
    },
    register: function (e, t) {
      (this.constructors[e] = t),
        $("[data-section-type=" + e + "]").each(
          function (e, i) {
            this._createInstance(i, t);
          }.bind(this)
        );
    },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function () {
      $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
      var e = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
        ),
        t = e.add(".rte iframe#admin_bar_iframe");
      e.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        t.each(function () {
          this.src = this.src;
        });
    },
  }),
  (window.slate = window.slate || {}),
  (slate.a11y = {
    pageLinkFocus: function (e) {
      var t = "js-focus-hidden";
      e.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(t)
        .one("blur", function () {
          e.first().removeClass(t).removeAttr("tabindex");
        });
    },
    focusHash: function () {
      var e = window.location.hash;
      e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (e) {
          this.pageLinkFocus($(e.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(t, function (t) {
          e.$container[0] === t.target ||
            e.$container.has(t.target).length ||
            e.$container.focus();
        });
    },
    removeTrapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$container &&
        e.$container.length &&
        e.$container.removeAttr("tabindex"),
        $(document).off(t);
    },
  }),
  (theme.Images = {
    preload: function (e, t) {
      "string" == typeof e && (e = [e]);
      for (var i = 0; i < e.length; i++) {
        var s = e[i];
        this.loadImage(this.getSizedImageUrl(s, t));
      }
    },
    loadImage: function (e) {
      new Image().src = e;
    },
    switchImage: function (e, t, i) {
      var s = this.imageSize(t.src),
        n = this.getSizedImageUrl(e.src, s);
      i ? i(n, e, t) : (t.src = n);
    },
    imageSize: function (e) {
      var t = e.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return null !== t ? t[1] : null;
    },
    getSizedImageUrl: function (e, t) {
      if (null == t) return e;
      if ("master" === t) return this.removeProtocol(e);
      var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != i) {
        var s = e.split(i[0]),
          n = i[0];
        return this.removeProtocol(s[0] + "_" + t + n);
      }
      return null;
    },
    removeProtocol: function (e) {
      return e.replace(/http(s)?:/, "");
    },
  }),
  (theme.Currency = {
    formatMoney: function (e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var i = "",
        s = /\{\{\s*(\w+)\s*\}\}/,
        n = t || "${{amount}}";
      function a(e, t, i, s) {
        if (
          ((t = t || 2), (i = i || ","), (s = s || "."), isNaN(e) || null == e)
        )
          return 0;
        var n = (e = (e / 100).toFixed(t)).split(".");
        return (
          n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (n[1] ? s + n[1] : "")
        );
      }
      switch (n.match(s)[1]) {
        case "amount":
          i = a(e, 2);
          break;
        case "amount_no_decimals":
          i = a(e, 0);
          break;
        case "amount_with_comma_separator":
          i = a(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          i = a(e, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          i = a(e, 0, " ");
      }
      return n.replace(s, i);
    },
  }),
  (slate.Variants = (function () {
    function e(e) {
      (this.$container = e.$container),
        (this.product = e.product),
        (this.singleOptionSelector = e.singleOptionSelector),
        (this.originalSelectorId = e.originalSelectorId),
        (this.variantTracker = e.variantTracker),
        (this.enableHistoryState = e.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        _getCurrentOptions: function () {
          var e = _.map(
            $(this.singleOptionSelector, this.$container),
            function (e) {
              var t = $(e),
                i = t.attr("type"),
                s = {};
              return "radio" === i || "checkbox" === i
                ? !!t[0].checked &&
                    ((s.value = t.val()), (s.index = t.data("index")), s)
                : ((s.value = t.val()), (s.index = t.data("index")), s);
            }
          );
          return _.compact(e);
        },
        _getVariantFromOptions: function () {
          var e = this._getCurrentOptions(),
            t = this.product.variants;
          return _.find(t, function (t) {
            return e.every(function (e) {
              return _.isEqual(t[e.index], e.value);
            });
          });
        },
        _filterThumbnails: function () {
            var e = this._getVariantFromOptions();
            var p = this.product;
            var color_index = false;
            var cleats_index = false;
            var color = false;
            var cleats = false;
            var cleats_unselected = false;
            var bedlength = '';
            var retreived_bed_info = '';
            var retrievedObject = false;
            var is_sxs = false;
          
            retrievedObject = localStorage.getItem('configuratorTruckInfo');
            retrievedObject = JSON.parse(retrievedObject);

             if(retrievedObject){
                retreived_bed_info = retrievedObject.bed;
              }

            switch(retreived_bed_info) {
              case "6'3\" REGULAR/ACCESS CAB":
                bedlength = 'short'
                break;
              case "6'4\"":
                bedlength = 'short'
                break;
              case "6.5'":
                bedlength = 'short'
                break;
              case "6'6\"":
                bedlength = 'short'
                break;
              case "6'7\"":
                bedlength = 'short'
                break;
              case "6'7\" (NOT CARBONPRO)":
                bedlength = 'short'
                break;
              case "6'9\"":
                bedlength = 'short'
                break;
              case "6'10\"":
                bedlength = 'short'
                break;
              case "7'3\"":
                bedlength = 'short'
                break;
              case "8'":
                bedlength = 'long'
                break;
              case "8'1\"":
                bedlength = 'long'
                break;
              case "8'2\"":
                bedlength = 'long'
                break;
              case "8'3\"":
                bedlength = 'long'
                break;
              default:
                bedlength = 'Both'
            }

            // console.log('bed:', bedlength);

            if(p.handle.includes('sxs')){
              is_sxs = true;
            }

            // console.log("fV Ptype:", p.type);

            p.options.forEach(function(item, index){
                // console.log('option:', item, index);
                if(item == 'Color'){
                    if(index === 0){
                        color = e.option1;
                    }
                    if(index === 1){
                        color = e.option2;
                    }
                }
                if(item == 'Cleats' || item == 'Anchor Cleats'){                    
                    if(index === 0){
                        cleats = e.option1;
                    }
                    if(index === 1){
                        cleats = e.option2;
                    }
                    if(index === 2){
                        cleats = e.option3;
                    }
                }
            });

            if(cleats == 'No' || cleats == 'Loose'){
                cleats = 'Loose';
            }else if(cleats == 'Yes' || cleats == 'Preinstalled' || cleats == 'Installed' ){
                cleats = 'Installed';
            }else if(cleats == '— SELECT —'){
              cleats_unselected = true;
            }else {
                cleats = color; 
            }

            // console.log('handle:', p.handle);
            // console.log('cleats:', cleats);
          
            if(color){
                $('.product-single__mobile-carousel').slick('slickUnfilter');
                $('#product-single__gallery_images li').addClass('show');

                if(is_sxs){
                      $('.product-single__mobile-carousel').slick('slickFilter',`[data-thumb-filter="${color}--${bedlength}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`);
                      $('#product-single__gallery_images li').not(`[data-thumb-filter="${color}--${bedlength}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`).removeClass('show');
                  
                }else {

                  if(cleats_unselected){
                      $('.product-single__mobile-carousel').slick('slickFilter',`[data-thumb-filter="${color}--Installed"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`);
                      $('#product-single__gallery_images li').not(`[data-thumb-filter="${color}--Installed"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`).removeClass('show');
                  }else{
                      $('.product-single__mobile-carousel').slick('slickFilter',`[data-thumb-filter="${color}--${cleats}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`);
                      $('#product-single__gallery_images li').not(`[data-thumb-filter="${color}--${cleats}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`).removeClass('show');
                  }
                }
                
            }else {
              $('#product-single__gallery_images li').addClass('show');
            }
            
            //$('.button-option.selected').trigger('click');
          
           // $('.product-single__mobile-carousel-item a').first().trigger('click');
        },
        _filterGridAndThumbnailImages: function () {
          var e = this._getVariantFromOptions();
          var p = this.product;
          var color_index = false;
          var cleats_index = false;
          var color = false;
          var cleats = false;
          var cleats_unselected = false;
          var bedlength = '';
          var retreived_bed_info = '';
          var retrievedObject = false;
          var is_sxs = false;

          // el caching
          let galleryImages = $('#product-single__gallery_images li');
          let gridImages = $('.product-images-grid__item');
        
          retrievedObject = localStorage.getItem('configuratorTruckInfo');
          retrievedObject = JSON.parse(retrievedObject);

           if(retrievedObject){
              retreived_bed_info = retrievedObject.bed;
            }

          switch(retreived_bed_info) {
            case "6'3\" REGULAR/ACCESS CAB":
              bedlength = 'short'
              break;
            case "6'4\"":
              bedlength = 'short'
              break;
            case "6.5'":
              bedlength = 'short'
              break;
            case "6'6\"":
              bedlength = 'short'
              break;
            case "6'7\"":
              bedlength = 'short'
              break;
            case "6'7\" (NOT CARBONPRO)":
              bedlength = 'short'
              break;
            case "6'9\"":
              bedlength = 'short'
              break;
            case "6'10\"":
              bedlength = 'short'
              break;
            case "7'3\"":
              bedlength = 'short'
              break;
            case "8'":
              bedlength = 'long'
              break;
            case "8'1\"":
              bedlength = 'long'
              break;
            case "8'2\"":
              bedlength = 'long'
              break;
            case "8'3\"":
              bedlength = 'long'
              break;
            default:
              bedlength = 'Both'
          }

          // console.log('bed:', bedlength);

          if(p.handle.includes('sxs')){
            is_sxs = true;
          }

          // console.log("fV Ptype:", p.type);

          p.options.forEach(function(item, index){
              // console.log('option:', item, index);
              if(item == 'Color'){
                  if(index === 0){
                      color = e.option1;
                  }
                  if(index === 1){
                      color = e.option2;
                  }
              }
              if(item == 'Cleats' || item == 'Anchor Cleats'){                    
                  if(index === 0){
                      cleats = e.option1;
                  }
                  if(index === 1){
                      cleats = e.option2;
                  }
                  if(index === 2){
                      cleats = e.option3;
                  }
              }
          });

          if(cleats == 'No' || cleats == 'Loose'){
              cleats = 'Loose';
          }else if(cleats == 'Yes' || cleats == 'Preinstalled' || cleats == 'Installed' ){
              cleats = 'Installed';
          }else if(cleats == '— SELECT —'){
            cleats_unselected = true;
          }else {
              cleats = color; 
          }
          // console.log('Grid called = = = = = =   == ');

          // console.log('handle:', p.handle);
          // console.log('color:', color);
        
          if(color){
              galleryImages.addClass('show');
              gridImages.removeClass('hide');
              
              var itemsToShow = '';
              
              if(is_sxs){
                itemsToShow = `[data-thumb-filter="${color}--${bedlength}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`
              }else {
                
                if(cleats_unselected){
                    itemsToShow = `[data-thumb-filter="${color}--Installed"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`
                }else{
                    itemsToShow = `[data-thumb-filter="${color}--${cleats}"], [data-thumb-filter="${color}--${color}"], [data-thumb-filter="${color}--Both"], [data-thumb-filter="All--Both"]`
                }

              }

              gridImages.not(itemsToShow).addClass('hide');
              galleryImages.not(itemsToShow).removeClass('show');
              
          }else {
            galleryImages.addClass('show');
          }
          
          //$('.button-option.selected').trigger('click');
        
         // $('.product-single__thumbnails-item a').first().trigger('click');

          if( $('.product-single__thumbnails-item').length > 5 ){
              $('.thumbnails-wrapper ').addClass('arrows--show');
          }else{
              $('.thumbnails-wrapper ').removeClass('arrows--show');
          }
          
      },
        _onSelectChange: function () {
          var e = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: e }),
            e &&
              (this._updateMasterSelect(e),
              this._updateImages(e),
              this._updateProductExtraInfo(e),
              this._updatePrice(e),
              this._updateQuantityAvailable(e),
              (this.currentVariant = e),
              this.enableHistoryState && this._updateHistoryState(e));
              
              // $('#variant_tracker').val(`${e.id}`).trigger('change');
              // $(this.variantTracker).val(`${e.id}`).trigger('change');

            if(this.product.type != "Gear"){
              this._filterGridAndThumbnailImages();
              this._filterThumbnails();
            }

            if( $('.variant__part_number').length > 0 ){
              $('.variant__part_number').text(e.sku);
            }

            if( $('.product-single__thumbnails-item').length > 5 ){
                $('.thumbnails-wrapper').removeClass('center');
            }else {
                $('.thumbnails-wrapper').addClass('center');
            }
            // let temp_v = $(this.variantTracker).val();
            // $(this.variantTracker).val(`${e.id}`);
            // register custom event?
            
            if(e){
              var event = new CustomEvent("variantupdated", {
                detail: {
                  variant: e.id
                }
              }); 
              document.dispatchEvent(event); 
            }else{
              var event = new CustomEvent("variantupdated", {
                detail: {
                  variant: "unavailable"
                }
              }); 
            }
            

        },
        _updateImages: function (e) {
          var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
          e.featured_image &&
            t.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: e });
        },
        _updateProductExtraInfo: function (e) {
          // console.log(variantSpecificData[e.id] );
          let dim_el = document.querySelector('.product-spec--dimensions');
          let folded_dim_el = document.querySelector('.product-spec--folded-dimensions');

          if(typeof variantSpecificData != 'undefined'  ){
            if(variantSpecificData[e.id].dimensions && dim_el){
              dim_el.innerHTML = variantSpecificData[e.id].dimensions;
            }
            
            if(variantSpecificData[e.id].foldedDimensions && folded_dim_el){
              folded_dim_el.innerHTML = variantSpecificData[e.id].foldedDimensions;
            }
          }
          
        },
        _updatePrice: function (e) {
          (e.price === this.currentVariant.price &&
            e.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant: e });

        },
        _updateQuantityAvailable: function (e) {
          this.$container.trigger({ type: "variantQuantityAvailableChange", variant: e });

        },
        _updateHistoryState: function(variant) {
          if (!history.replaceState || !variant) {
            return;
          }
          
          var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              variant.id;
          
        var pastParam = this._getAllParameters('variant')

        // console.log('pastParam', pastParam);
      
        if (pastParam != '') {
          newurl += `&${pastParam}`
        }
      
        window.history.replaceState({ path: newurl }, "", newurl);
      },
      
      /* Get all Paramter */
      _getAllParameters: function(except='none') {
        var result = '',
          tmp = [],
          idx = 0;

          // console.log('location.search ::', location.search);
      
        location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            // console.log('item ::', item);

          if(item != ''){
            tmp = item.split("=");
            if ((except == 'none') || (tmp[0] !== except)) {
              if (idx != 0) {
                result += '&';
              }
              idx++;
              result += `${tmp[0]}=${decodeURIComponent(tmp[1])}`;
            }
          }

          });
        return result;
      },
        _updateMasterSelect: function (e) {
          $(this.originalSelectorId, this.$container).val(e.id);
          
        },
      })),
      e
    );
  })()),
  (theme.Drawers = (function () {
    function e(e, t, i) {
      var s = {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + t,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + t,
      };
      if (
        ((this.nodes = {
          $parent: $("html").add("body"),
          $page: $("#PageContainer"),
        }),
        (this.config = $.extend(s, i)),
        (this.position = t),
        (this.$drawer = $("#" + e)),
        !this.$drawer.length)
      )
        return !1;
      (this.drawerIsOpen = !1), this.init();
    }
    return (
      (e.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this)),
          this.$drawer.on(
            "click",
            this.config.close,
            $.proxy(this.close, this)
          );
      }),
      (e.prototype.open = function (e) {
        var t = !1;
        return (
          e ? e.preventDefault() : (t = !0),
          e &&
            e.stopPropagation &&
            (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))),
          this.drawerIsOpen && !t
            ? this.close()
            : (this.$drawer.prepareTransition(),
              this.nodes.$parent.addClass(
                this.config.openClass + " " + this.config.dirOpenClass
              ),
              (this.drawerIsOpen = !0),
              slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus",
              }),
              this.config.onDrawerOpen &&
                "function" == typeof this.config.onDrawerOpen &&
                (t || this.config.onDrawerOpen()),
              this.$activeSource &&
                this.$activeSource.attr("aria-expanded") &&
                this.$activeSource.attr("aria-expanded", "true"),
              this.bindEvents(),
              this)
        );
      }),
      (e.prototype.close = function () {
        this.drawerIsOpen &&
          ($(document.activeElement).trigger("blur"),
          this.$drawer.prepareTransition(),
          this.nodes.$parent.removeClass(
            this.config.dirOpenClass + " " + this.config.openClass
          ),
          (this.drawerIsOpen = !1),
          slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
          }),
          this.unbindEvents());
      }),
      (e.prototype.bindEvents = function () {
        this.nodes.$parent.on(
          "keyup.drawer",
          $.proxy(function (e) {
            return 27 !== e.keyCode || (this.close(), !1);
          }, this)
        ),
          this.nodes.$page.on("touchmove.drawer", function () {
            return !1;
          }),
          this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
              return this.close(), !1;
            }, this)
          );
      }),
      (e.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
      }),
      e
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
    var e = {
        body: "body",
        navigation: "#AccessibleNav",
        siteNavHasDropdown: ".site-nav--has-dropdown",
        siteNavChildLinks: ".site-nav__child-link",
        siteNavActiveDropdown: ".site-nav--active-dropdown",
        siteNavLinkMain: ".site-nav__link--main",
        siteNavChildLink: ".site-nav__link--last",
      },
      t = {
        activeClass: "site-nav--active-dropdown",
        childLinkClass: "site-nav__child-link",
      },
      i = {};
    function s(s) {
      s.find(e.siteNavLinkMain).attr("aria-expanded", "false"),
        s.removeClass(t.activeClass),
        (i.$activeDropdown = $(e.siteNavActiveDropdown)),
        $(e.body).off("click.siteNav"),
        $(window).off("keyup.siteNav");
    }
    return {
      init: function () {
        (i = {
          $nav: $(e.navigation),
          $topLevel: $(e.siteNavLinkMain),
          $parents: $(e.navigation).find(e.siteNavHasDropdown),
          $subMenuLinks: $(e.siteNavChildLinks),
          $activeDropdown: $(e.siteNavActiveDropdown),
        }).$parents.on("click.siteNav", function (n) {
          var a,
            o = $(this);
          o.hasClass(t.activeClass) ||
            (n.preventDefault(), n.stopImmediatePropagation()),
            (a = o).addClass(t.activeClass),
            i.$activeDropdown.length && s(i.$activeDropdown),
            (i.$activeDropdown = a),
            a.find(e.siteNavLinkMain).attr("aria-expanded", "true"),
            setTimeout(function () {
              $(window).on("keyup.siteNav", function (e) {
                27 === e.keyCode && s(a);
              }),
                $(e.body).on("click.siteNav", function () {
                  s(a);
                });
            }, 250);
        }),
          $(e.siteNavChildLink).on("focusout.siteNav", function () {
            setTimeout(function () {
              !$(document.activeElement).hasClass(t.childLinkClass) &&
                i.$activeDropdown.length &&
                s(i.$activeDropdown);
            });
          }),
          i.$topLevel.on("focus.siteNav", function () {
            i.$activeDropdown.length && s(i.$activeDropdown);
          }),
          i.$subMenuLinks.on("click.siteNav", function (e) {
            e.stopImmediatePropagation();
          });
      },
      unload: function () {
        $(window).off(".siteNav"),
          i.$parents.off(".siteNav"),
          i.$subMenuLinks.off(".siteNav"),
          i.$topLevel.off(".siteNav"),
          $(e.siteNavChildLink).off(".siteNav"),
          $(e.body).off(".siteNav");
      },
    };
  })()),
  (window.theme = window.theme || {}),
  (theme.MobileNav = (function () {
    var e,
      t,
      i,
      s = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavCloseIcon: "mobile-nav--close",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
      },
      n = {},
      a = 1;
    function o() {
      var e;
      n.$mobileNavToggle.hasClass(s.mobileNavCloseIcon)
        ? r()
        : ((e = n.$siteHeader.outerHeight() + n.$siteHeader.offset().top),
          n.$mobileNavContainer.prepareTransition().addClass(s.navOpen),
          n.$mobileNavContainer.css({
            transform: "translate3d(0, " + e + "px, 0)",
          }),
          n.$pageContainer.css({
            transform:
              "translate3d(0, " +
              n.$mobileNavContainer[0].scrollHeight +
              "px, 0)",
          }),
          slate.a11y.trapFocus({
            $container: n.$mobileNav,
            namespace: "navFocus",
          }),
          n.$mobileNavToggle
            .addClass(s.mobileNavCloseIcon)
            .removeClass(s.mobileNavOpenIcon),
          $(window).on("keyup.mobileNav", function (e) {
            27 === e.which && r();
          }));
    }
    function r() {
      n.$mobileNavContainer.prepareTransition().removeClass(s.navOpen),
        n.$mobileNavContainer.css({ transform: "translate3d(0, -100%, 0)" }),
        n.$pageContainer.removeAttr("style"),
        n.$mobileNavContainer.one(
          "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
          function () {
            slate.a11y.removeTrapFocus({
              $container: n.$mobileNav,
              namespace: "navFocus",
            });
          }
        ),
        n.$mobileNavToggle
          .addClass(s.mobileNavOpenIcon)
          .removeClass(s.mobileNavCloseIcon),
        $(window).off("keyup.mobileNav");
    }
    function c(o) {
      if (!e) {
        var r = $(o.currentTarget),
          c = r.hasClass(s.return);
        (e = !0),
          c
            ? ($(
                "." + s.subNavToggleBtn + '[data-level="' + (a - 1) + '"]'
              ).removeClass(s.subNavActive),
              i && i.length && i.removeClass(s.subNavActive))
            : r.addClass(s.subNavActive),
          (i = r),
          (function (o) {
            var r = o
              ? $('.mobile-nav__dropdown[data-parent="' + o + '"]')
              : n.$mobileNav;
            (a = r.data("level") ? r.data("level") : 1),
              t && t.length && t.prepareTransition().addClass(s.subNavClosing),
              (t = r);
            var c = o ? r.find("." + s.subNavLink + ":first") : i,
              d = r[0].scrollHeight;
            o || (d = r.outerHeight());
            var l = a > 2 ? s.thirdNavShowing : s.subNavShowing;
            n.$mobileNavContainer
              .css("height", d)
              .removeClass(s.thirdNavShowing)
              .addClass(l),
              o ||
                n.$mobileNavContainer
                  .removeClass(s.thirdNavShowing)
                  .removeClass(s.subNavShowing),
              n.$mobileNavContainer.one(
                "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
                function () {
                  slate.a11y.trapFocus({
                    $container: r,
                    $elementToFocus: c,
                    namespace: "subNavFocus",
                  }),
                    n.$mobileNavContainer.off(".subnavToggle"),
                    (e = !1);
                }
              ),
              n.$pageContainer.css({
                transform: "translate3d(0, " + d + "px, 0)",
              }),
              t.removeClass(s.subNavClosing);
          })(r.data("target"));
      }
    }
    return {
      init: function () {
        (n = {
          $pageContainer: $("#PageContainer"),
          $siteHeader: $(".site-header"),
          $mobileNavToggle: $(".js-mobile-nav-toggle"),
          $mobileNavContainer: $(".mobile-nav-wrapper"),
          $mobileNav: $("#MobileNav"),
          $subNavToggleBtn: $("." + s.subNavToggleBtn),
        }).$mobileNavToggle.on("click", o),
          n.$subNavToggleBtn.on("click.subNav", c),
          enquire.register("screen and (max-width: 749px)", {
            unmatch: function () {
              r();
            },
          });
      },
      closeMobileNav: r,
    };
  })(jQuery)),
  (window.theme = window.theme || {}),
  (theme.Search = (function () {
    var e = {
        search: ".search",
        searchSubmit: "#RightNav .search__submit",
        searchInput: ".search__input",
        siteHeader: ".header-wrap",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderMobileSearchToggle: "#mobile-search__trigger",
        siteHeaderMobileSearchClose: "#mobile-search__close",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderMobile: "#mobile-search__container .search-header",
        searchHeaderInput: "#RightNav .search-header__input",
        searchHeaderSubmit: "#RightNav .search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
      },
      t = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    function i() {
      s($(e.searchDrawerInput)),
        $(e.mobileNavWrapper).hasClass(t.mobileNavIsOpen) &&
          theme.MobileNav.closeMobileNav();
    }
    function s(e) {
      e.focus(), e[0].setSelectionRange(0, e[0].value.length);
    }
    return {
      init: function () {
        $(e.siteHeader).length &&
          ($("#PageContainer").addClass("drawer-page-content"),
          $(".js-drawer-open-top")
            .attr("aria-controls", "SearchDrawer")
            .attr("aria-expanded", "false"),
          (theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
            onDrawerOpen: i,
          })),
          $(e.searchSubmit).on("click", function (t) {
            var i = $(t.target).parents(e.search).find(e.searchInput);
            0 === i.val().length && (t.preventDefault(), s(i));
          }),
          $(e.searchHeaderInput)
            .add(e.searchHeaderSubmit)
            .on("focus blur", function () {
              $(e.searchHeader).toggleClass(t.focus);
              $('body').toggleClass(t.focus);
            }),
          $(e.siteHeaderMobileSearchToggle).on("click", function () {
            $('body').toggleClass(t.focus);
            $(e.searchHeaderMobile).toggleClass(t.focus);
          }),
          $(e.siteHeaderMobileSearchClose).on("click", function () {
              // console.log('close');
            $('body').removeClass(t.focus);
            $(e.searchHeaderMobile).removeClass(t.focus);
          }),
          $(e.siteHeaderSearchToggle).on("click", function () {
            var t = $(e.siteHeader).outerHeight(),
              i = $(e.siteHeader).offset().top - t;
            $(e.searchDrawer).css({ height: t + "px", top: i + "px" });
          }));
      },
    };
  })()),
  (function () {
    var e = $(".return-link");
    function t(e) {
      var t = document.createElement("a");
      return (t.ref = e), t.hostname;
    }
    document.referrer &&
      e.length &&
      window.history.length &&
      e.one("click", function (e) {
        e.preventDefault();
        var i = t(document.referrer);
        return t(window.location.href) === i && history.back(), !1;
      });
  })(),
  (theme.Slideshow = (function () {
    this.$slideshow = null;
    var e = {
      wrapper: "slideshow-wrapper",
      slideshow: "slideshow",
      currentSlide: "slick-current",
      video: "slideshow__video",
      videoBackground: "slideshow__video--background",
      closeVideoBtn: "slideshow__video-control--close",
      pauseButton: "slideshow__pause",
      isPaused: "is-paused",
    };
    function t(t) {
      (this.$slideshow = $(t)),
        (this.$wrapper = this.$slideshow.closest("." + e.wrapper)),
        (this.$pause = this.$wrapper.find("." + e.pauseButton)),
        (this.settings = {
          accessibility: !0,
          arrows: !1,
          dots: !0,
          fade: !0,
          draggable: !0,
          touchThreshold: 20,
          autoplay: this.$slideshow.data("autoplay"),
          autoplaySpeed: this.$slideshow.data("speed"),
        }),
        this.$slideshow.on(
          "beforeChange",
          function (t, s, n, a) {
            var o = s.$slider,
              r = o.find("." + e.currentSlide),
              c = o.find('.slideshow__slide[data-slick-index="' + a + '"]');
            if (i(r)) {
              var d = r.find("." + e.video),
                l = d.attr("id");
              theme.SlideshowVideo.pauseVideo(l), d.attr("tabindex", "-1");
            }
            if (i(c)) {
              var h = c.find("." + e.video),
                u = h.attr("id");
              h.hasClass(e.videoBackground)
                ? theme.SlideshowVideo.playVideo(u)
                : h.attr("tabindex", "0");
            }
          }.bind(this)
        ),
        this.$slideshow.on(
          "init",
          function (t, i) {
            var s = i.$slider,
              n = i.$list,
              a = this.$wrapper,
              o = this.settings.autoplay;
            n.removeAttr("aria-live"),
              a.on("focusin", function (e) {
                a.has(e.target).length &&
                  (n.attr("aria-live", "polite"), o && s.slick("slickPause"));
              }),
              a.on("focusout", function (t) {
                if (a.has(t.target).length && (n.removeAttr("aria-live"), o)) {
                  if ($(t.target).hasClass(e.closeVideoBtn)) return;
                  s.slick("slickPlay");
                }
              }),
              i.$dots &&
                i.$dots.on("keydown", function (e) {
                  37 === e.which && s.slick("slickPrev"),
                    39 === e.which && s.slick("slickNext"),
                    (37 !== e.which && 39 !== e.which) ||
                      i.$dots.find(".slick-active button").focus();
                });
          }.bind(this)
        ),
        this.$slideshow.slick(this.settings),
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function i(t) {
      return t.find("." + e.video).length;
    }
    return (
      (t.prototype.togglePause = function () {
        var t = "#Slideshow-" + this.$pause.data("id");
        this.$pause.hasClass(e.isPaused)
          ? (this.$pause.removeClass(e.isPaused), $(t).slick("slickPlay"))
          : (this.$pause.addClass(e.isPaused), $(t).slick("slickPause"));
      }),
      t
    );
  })()),
  (theme.SlideshowVideo = (function () {
    var e = !1,
      t = !1,
      i = !1,
      s = !1,
      n = !1,
      a = {},
      o = [],
      r = {
        ratio: 16 / 9,
        playerVars: {
          iv_load_policy: 3,
          modestbranding: 1,
          autoplay: 0,
          controls: 0,
          showinfo: 0,
          wmode: "opaque",
          branding: 0,
          autohide: 0,
          rel: 0,
        },
        events: {
          onReady: function (e) {
            e.target.setPlaybackQuality("hd1080");
            var t = m(e);
            switch (
              (i ||
                ($(window).width() < 750
                  ? (s = !0)
                  : window.mobileCheck() && (s = !0),
                s && l(!1),
                (i = !0)),
              $("#" + t.id).attr("tabindex", "-1"),
              g(),
              t.type)
            ) {
              case "background-chrome":
              case "background":
                e.target.mute(),
                  t.$parentSlide.hasClass(c.currentSlide) && d(t.id);
            }
            t.$parentSlide.addClass(c.loaded);
          },
          onStateChange: function (e) {
            var t = m(e);
            switch (e.data) {
              case 0:
                !(function (e) {
                  switch (e.type) {
                    case "background":
                      o[e.id].seekTo(0);
                      break;
                    case "background-chrome":
                      o[e.id].seekTo(0), p(e.id);
                      break;
                    case "chrome":
                      p(e.id);
                  }
                })(t);
                break;
              case 1:
                h(t);
                break;
              case 2:
                u(t);
            }
          },
        },
      },
      c = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        slideshowWrapper: "slideshow-wrapper",
        slide: "slideshow__slide",
        slideBackgroundVideo: "slideshow__slide--background-video",
        slideDots: "slick-dots",
        videoChrome: "slideshow__video--chrome",
        videoBackground: "slideshow__video--background",
        playVideoBtn: "slideshow__video-control--play",
        closeVideoBtn: "slideshow__video-control--close",
        currentSlide: "slick-current",
        slickClone: "slick-cloned",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
      };
    function d(i, n) {
      var r,
        d,
        u,
        p,
        m,
        g,
        v = a[i],
        f = o[i],
        w = a[i].$parentSlide;
      if (s) h(v);
      else if (n || (e && t))
        return w.removeClass(c.loading), h(v), void f.playVideo();
      e ||
        ((d = w),
        (r = f).playVideo(),
        ((u = r),
        (g = $.Deferred()),
        (p = setInterval(function () {
          u.getCurrentTime() <= 0 ||
            ((t = !0), clearInterval(p), clearTimeout(m), g.resolve());
        }, 500)),
        (m = setTimeout(function () {
          clearInterval(p), g.reject();
        }, 4e3)),
        g)
          .then(function () {
            l(!0);
          })
          .fail(function () {
            l(!1), r.stopVideo();
          })
          .always(function () {
            (e = !0), d.removeClass(c.loading);
          }));
    }
    function l(t) {
      var i = t ? c.supportsAutoplay : c.supportsNoAutoplay;
      $(document.documentElement).addClass(i), t || (s = !0), (e = !0);
    }
    function h(e) {
      var t = e.$parentSlideshowWrapper,
        i = e.$parentSlide;
      if ((i.removeClass(c.loading), "background" !== e.status)) {
        switch (($("#" + e.id).attr("tabindex", "0"), e.type)) {
          case "chrome":
          case "background-chrome":
            t.removeClass(c.paused).addClass(c.playing),
              i.removeClass(c.paused).addClass(c.playing);
        }
        i.find("." + c.closeVideoBtn).focus();
      }
    }
    function u(e) {
      var t = e.$parentSlideshowWrapper,
        i = e.$parentSlide;
      "background-chrome" !== e.type
        ? ("closed" !== e.status &&
            "background" !== e.type &&
            (t.addClass(c.paused), i.addClass(c.paused)),
          "chrome" === e.type &&
            "closed" === e.status &&
            (t.removeClass(c.paused), i.removeClass(c.paused)),
          t.removeClass(c.playing),
          i.removeClass(c.playing))
        : p(e.id);
    }
    function p(e) {
      var t,
        i,
        s = a[e],
        n = s.$parentSlideshowWrapper,
        r = s.$parentSlide,
        d = [c.pause, c.playing].join(" ");
      switch (
        ($("#" + s.id).attr("tabindex", "-1"), (s.status = "closed"), s.type)
      ) {
        case "background-chrome":
          o[e].mute(),
            (t = e),
            (i = $("#" + t)
              .addClass(c.videoBackground)
              .removeClass(c.videoChrome)),
            a[t].$parentSlide.addClass(c.slideBackgroundVideo),
            (a[t].status = "background"),
            v(i);
          break;
        case "chrome":
          o[e].stopVideo(), u(s);
      }
      n.removeClass(d), r.removeClass(d);
    }
    function m(e) {
      return a[e.target.h.id];
    }
    function g() {
      $("." + c.videoBackground).each(function (e, t) {
        v($(t));
      });
    }
    function v(e) {
      var t = e.closest("." + c.slide);
      if (!t.hasClass(c.slickClone)) {
        var i = t.width(),
          s = e.width(),
          n = e.height();
        i / r.ratio < n
          ? ((s = Math.ceil(n * r.ratio)),
            e
              .width(s)
              .height(n)
              .css({ left: (i - s) / 2, top: 0 }))
          : ((n = Math.ceil(i / r.ratio)),
            e
              .width(i)
              .height(n)
              .css({ left: 0, top: (n - n) / 2 })),
          e.prepareTransition().addClass(c.loaded);
      }
    }
    function f() {
      $(document).on("click.videoPlayer", "." + c.playVideoBtn, function (e) {
        !(function (e) {
          var t,
            i = a[e];
          switch (
            (i.$parentSlide.addClass(c.loading), (i.status = "open"), i.type)
          ) {
            case "background-chrome":
              (t = e),
                $("#" + t)
                  .removeAttr("style")
                  .removeClass(c.videoBackground)
                  .addClass(c.videoChrome),
                a[t].$parentSlideshowWrapper
                  .removeClass(c.slideBackgroundVideo)
                  .addClass(c.playing),
                a[t].$parentSlide
                  .removeClass(c.slideBackgroundVideo)
                  .addClass(c.playing),
                (a[t].status = "open"),
                o[e].unMute(),
                d(e, !0);
              break;
            case "chrome":
              d(e, !0);
          }
          $(document).on("keydown.videoPlayer", function (t) {
            27 === t.keyCode && p(e);
          });
        })($(e.currentTarget).data("controls"));
      }),
        $(document).on("click.videoPlayer", "." + c.closeVideoBtn, function (
          e
        ) {
          p($(e.currentTarget).data("controls"));
        }),
        $(window).on(
          "resize.videoPlayer",
          $.debounce(250, function () {
            n && g();
          })
        );
    }
    return {
      init: function (e) {
        if (
          e.length &&
          ((a[e.attr("id")] = {
            id: e.attr("id"),
            videoId: e.data("id"),
            type: e.data("type"),
            status: "chrome" === e.data("type") ? "closed" : "background",
            videoSelector: e.attr("id"),
            $parentSlide: e.closest("." + c.slide),
            $parentSlideshowWrapper: e.closest("." + c.slideshowWrapper),
            controls: "background" === e.data("type") ? 0 : 1,
            slideshow: e.data("slideshow"),
          }),
          !n)
        ) {
          var t = document.createElement("script");
          t.src = "https://www.youtube.com/iframe_api";
          var i = document.getElementsByTagName("script")[0];
          i.parentNode.insertBefore(t, i);
        }
      },
      loadVideos: function () {
        for (var e in a)
          if (a.hasOwnProperty(e)) {
            var t = $.extend({}, r, a[e]);
            (t.playerVars.controls = t.controls), (o[e] = new YT.Player(e, t));
          }
        f(), (n = !0);
      },
      loadVideo: function (e) {
        if (n) {
          var t = $.extend({}, r, a[e]);
          (t.playerVars.controls = t.controls),
            (o[e] = new YT.Player(e, t)),
            f();
        }
      },
      playVideo: function (e) {
        (i || s) && e && "function" == typeof o[e].playVideo && d(e);
      },
      pauseVideo: function (e) {
        o[e] && "function" == typeof o[e].pauseVideo && o[e].pauseVideo();
      },
      removeEvents: function () {
        $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
      },
    };
  })()),
  (function () {
    var e = $("#BlogTagFilter");
    e.length &&
      e.on("change", function () {
        location.href = $(this).val();
      });
  })(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
    function e() {
      $("#RecoverPasswordForm").toggleClass("hide"),
        $("#CustomerLoginForm").toggleClass("hide");
    }
    return {
      init: function () {
        var t;
        "#recover" === window.location.hash && e(),
          $("#RecoverPassword").on("click", function (t) {
            t.preventDefault(), e();
          }),
          $("#HideRecoverPasswordLink").on("click", function (t) {
            t.preventDefault(), e();
          }),
          $(".reset-password-success").length &&
            $("#ResetSuccess").removeClass("hide"),
          (t = $("#AddressNewForm")).length &&
            (Shopify &&
              new Shopify.CountryProvinceSelector(
                "AddressCountryNew",
                "AddressProvinceNew",
                { hideElement: "AddressProvinceContainerNew" }
              ),
            $(".address-country-option").each(function () {
              var e = $(this).data("form-id"),
                t = "AddressCountry_" + e,
                i = "AddressProvince_" + e,
                s = "AddressProvinceContainer_" + e;
              new Shopify.CountryProvinceSelector(t, i, { hideElement: s });
            }),
            $(".address-new-toggle").on("click", function () {
              t.toggleClass("hide");
            }),
            $(".address-edit-toggle").on("click", function () {
              var e = $(this).data("form-id");
              $("#EditAddress_" + e).toggleClass("hide");
            }),
            $(".address-delete").on("click", function () {
              var e = $(this),
                t = e.data("form-id"),
                i = e.data("confirm-message");
              confirm(i || "Are you sure you wish to delete this address?") &&
                Shopify.postLink("/account/addresses/" + t, {
                  parameters: { _method: "delete" },
                });
            }));
      },
    };
  })()),
  (window.theme = window.theme || {}),
  (theme.Cart = (function () {
    var e = { edit: ".js-edit-toggle" };
    function t(t) {
      (this.$container = $(t)),
        (this.$edit = $(e.edit, this.$container)),
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    return (
      (t.prototype = _.assignIn({}, t.prototype, {
        onUnload: function () {
          this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function (e) {
          var t = $(e.target),
            i = $("." + t.data("target"));
          t.toggleClass("cart__edit--active"),
            i.toggleClass("cart__update--show");
        },
      })),
      t
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Filters = (function () {
    var e = {
      filterSelection: ".filters-toolbar__input--filter",
      sortSelection: ".filters-toolbar__input--sort",
      defaultSort: ".filters-toolbar__default-sort",
    };
    function t(t) {
      var i = (this.$container = $(t));
      (this.$filterSelect = $(e.filterSelection, i)),
        (this.$sortSelect = $(e.sortSelection, i)),
        (this.$selects = $(e.filterSelection, i).add($(e.sortSelection, i))),
        (this.defaultSort = this._getDefaultSortValue()),
        this._resizeSelect(this.$selects),
        this.$selects.removeClass("hidden"),
        this.$filterSelect.on("change", this._onFilterChange.bind(this)),
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    return (
      (t.prototype = _.assignIn({}, t.prototype, {
        _onSortChange: function (e) {
          var t = "";
          (this.sort = this._getSortValue()),
            this.sort !== this.defaultSort && (t = ["sort_by=" + this.sort]);
          var i = (document.location.search = t.length ? "?" + t : "");
          (document.location.href = this.$filterSelect.val() + i),
            this._resizeSelect($(e.target));
        },
        _onFilterChange: function (e) {
          (document.location.href = this.$filterSelect.val()),
            this._resizeSelect($(e.target));
        },
        _getSortValue: function () {
          return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function () {
          return $(e.defaultSort, this.$container).val() || "title-ascending";
        },
        _resizeSelect: function (e) {
          e.each(function () {
            var e = $(this),
              t = e.find("option:selected").text(),
              i = $("<span>").html(t);
            i.appendTo("body");
            var s = i.width();
            i.remove(), e.width(s + 10);
          });
        },
        onUnload: function () {
          this.$filterSelect.off("change", this._onFilterChange),
            this.$sortSelect.off("change", this._onSortChange);
        },
      })),
      t
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
    function e() {
      theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function () {
          theme.Header.unload();
        },
      })),
      e
    );
  })()),
  (theme.Maps = (function () {
    var e = null,
      t = [],
      i = theme.mapKey ? theme.mapKey : "";
    function s(s) {
      (this.$container = $(s)),
        "loaded" === e
          ? this.createMap()
          : (t.push(this),
            "loading" !== e &&
              ((e = "loading"),
              void 0 === window.google &&
                $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + i
                ).then(function () {
                  (e = "loaded"),
                    $.each(t, function (e, t) {
                      t.createMap();
                    });
                })));
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        createMap: function () {
          var e,
            t,
            i,
            s,
            n = this.$container.find(".map-section__container");
          return ((e = n),
          (t = $.Deferred()),
          (i = new google.maps.Geocoder()),
          (s = e.data("address-setting")),
          i.geocode({ address: s }, function (e, i) {
            i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
          }),
          t)
            .then(
              function (e) {
                var t = {
                    zoom: 14,
                    center: e[0].geometry.location,
                    disableDefaultUI: !0,
                  },
                  i = (this.map = new google.maps.Map(n[0], t)),
                  s = (this.center = i.getCenter());
                new google.maps.Marker({ map: i, position: i.getCenter() }),
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    $.debounce(250, function () {
                      google.maps.event.trigger(i, "resize"), i.setCenter(s);
                    })
                  );
              }.bind(this)
            )
            .fail(function () {
              var e;
              switch (status) {
                case "ZERO_RESULTS":
                  e = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  e = theme.strings.addressQueryLimit;
                  break;
                default:
                  e = theme.strings.addressError;
              }
              n.parent()
                .addClass("page-width map-section--load-error")
                .html('<div class="errors text-center">' + e + "</div>");
            });
        },
        onUnload: function () {
          google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      s
    );
  })()),
  (theme.Product = (function () {
    function e(e) {
      var t = (this.$container = $(e)),
        i = t.attr("data-section-id");
      (this.settings = {
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        mediaQuerySmall: "screen and (max-width: 749px)",
        bpSmall: !1,
        enableHistoryState: t.data("enable-history-state") || !1,
        imageSize: null,
        imageZoomSize: null,
        namespace: ".slideshow-" + i,
        sectionId: i,
        sliderActive: !1,
        zoomEnabled: !1,
      }),
        (this.selectors = {
          addToCart: "#AddToCart-" + i,
          addToCartText: "#AddToCartText-" + i,
          comparePrice: "#ComparePrice-" + i,
          originalPrice: "#ProductPrice-" + i,
          originalMobilePrice: "#MobileProductPrice-" + i,
          originalPriceWrapper: ".product-price__price-" + i,
          originalSelectorId: "#ProductSelect-" + i,
          variantTracker: "#variant_tracker",
          productFeaturedImage: "#FeaturedImage-" + i,
          productImageWrap: "#FeaturedImageZoom-" + i,
          productPrices: ".product-single__price-" + i,
          productThumbImages: ".product-single__thumbnail--" + i,
          productThumbs: ".product-single__thumbnails-" + i,
          saleClasses: "product-price__sale product-price__sale--single",
          saleLabel: ".product-price__sale-label-" + i,
          singleOptionSelector: ".single-option-selector-" + i,
          affirmAsLowAs: ".affirm-as-low-as-" + i,
          productQuantityAvailable: "#product-form__left-in-stock_" + i,
          productBisBtn: ".klaviyo-bis-trigger",
        }),
        $("#ProductJson-" + i).html() &&
          ((this.productSingleObject = JSON.parse(
            document.getElementById("ProductJson-" + i).innerHTML
          )),
          (this.settings.zoomEnabled = $(
            this.selectors.productFeaturedImage
          ).hasClass("js-zoom-enabled")),
          (this.settings.imageSize = theme.Images.imageSize(
            $(this.selectors.productFeaturedImage).attr("src")
          )),
          this.settings.zoomEnabled &&
            (this.settings.imageZoomSize = theme.Images.imageSize(
              $(this.selectors.productImageWrap).data("zoom")
            )),
          this._initBreakpoints(),
          this._stringOverrides(),
          this._initVariants(),
          this._initImageSwitch(),
          this._setActiveThumbnail(),
          theme.Images.preload(
            this.productSingleObject.images,
            this.settings.imageSize
          ));
    }
    function t(e) {
      var t = e.data("zoom");
      e.zoom({ url: t });
    }
    function i(e) {
      e.trigger("zoom.destroy");
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        _stringOverrides: function () {
          (theme.productStrings = theme.productStrings || {}),
            $.extend(theme.strings, theme.productStrings);
        },
        _initBreakpoints: function () {
          var e = this;
          enquire.register(this.settings.mediaQuerySmall, {
            match: function () {
              $(e.selectors.productThumbImages).length > 0 &&
                e._initThumbnailSlider(),
                e.settings.zoomEnabled && i($(e.selectors.productImageWrap)),
                (e.settings.bpSmall = !0);
            },
            unmatch: function () {
              e.settings.sliderActive && e._destroyThumbnailSlider(),
                (e.settings.bpSmall = !1);
            },
          }),
            enquire.register(this.settings.mediaQueryMediumUp, {
              match: function () {
                e._initThumbnailSlider(),
                e.settings.zoomEnabled && t($(e.selectors.productImageWrap));
              },
            });
        },
        _initVariants: function () {
          var e = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            variantTracker: this.selectors.variantTracker,
            product: this.productSingleObject,
          };
          (this.variants = new slate.Variants(e)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAddToCart.bind(this)
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateImages.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this)
            ),
            this.$container.on(
              "variantQuantityAvailableChange" + this.settings.namespace,
              this._updateQuantityAvailable.bind(this)
            );
        },
        _initImageSwitch: function () {
          if ($(this.selectors.productThumbImages).length) {
            var e = this;
            $(this.selectors.productThumbImages).on("click", function (t) {
//                 console.log("t: ", t);
              t.preventDefault();
              var i = $(this),
                s = i.attr("href"),
                n = i.data("zoom");
              e._switchImage(s, n), e._setActiveThumbnail(s);
            });
          }
        },
        _setActiveThumbnail: function (e) {
          var t = "active-thumb";
          void 0 === e &&
            (e = $(this.selectors.productFeaturedImage).attr("src"));
          var i = $(this.selectors.productThumbImages + '[href="' + e + '"]');
          var index = i.parent().attr('data-slick-index');

          $(this.selectors.productThumbImages).removeClass(t), i.addClass(t);          
        },
        _switchImage: function (e, s) {
          $(this.selectors.productFeaturedImage).attr("src", e),
            this.settings.zoomEnabled && i($(this.selectors.productImageWrap)),
            !this.settings.bpSmall &&
              this.settings.zoomEnabled &&
              s &&
              ($(this.selectors.productImageWrap).data("zoom", s),
              t($(this.selectors.productImageWrap)));
        },
        _initThumbnailSlider: function () {
          var e = {
            slidesToShow: 5,
            slidesToScroll: 1,
//             mobileFirst:true,
            prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
            nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
            'responsive': [{ breakpoint: 600, settings: { slidesToShow: 3, slidesToScroll: 1, } }]
          };
//           $(this.selectors.productThumbs).slick(e),
//             (this.settings.sliderActive = !0);
        },
        _destroyThumbnailSlider: function () {
          $(this.selectors.productThumbs).slick("unslick"),
            (this.settings.sliderActive = !1);
        },
        _updateAddToCart: function (e) {
          var t = e.variant;

          console.log('e', e);

          if(!$('.anchor-cleats-option').hasClass('masked-selection')){

          
          
            if($('.color-option').length > 0 && $('.anchorcleats-option').length > 0 ){
              if(!$('.color-option').hasClass('selected') || !$('.anchor-cleats-option').hasClass('selected') ){
                t = !1;
              }
            }

            if($(this.selectors.productBisBtn).length > 0){
              t.available
                ? ($(this.selectors.addToCart).prop("disabled", !1),
                  $(this.selectors.addToCartText).text(theme.strings.addToCart),
                  $(this.selectors.productBisBtn).hide(),
                  $(this.selectors.addToCart).show())
                : ($(this.selectors.addToCart).prop("disabled", !0),
                  $(this.selectors.addToCartText).text(theme.strings.soldOut),
                  $(this.selectors.productBisBtn).show(),
                  $(this.selectors.addToCart).hide())
            }
            
            t
              ? ($(this.selectors.productPrices)
                  .removeClass("visibility-hidden")
                  .attr("aria-hidden", "true"),
                t.available
                  ? ($(this.selectors.addToCart).prop("disabled", !1),
                    $(this.selectors.addToCartText).text(theme.strings.addToCart)
                    )
                  : ($(this.selectors.addToCart).prop("disabled", !0),
                    $(this.selectors.addToCartText).text(theme.strings.soldOut)))
              : ($(this.selectors.addToCart).prop("disabled", !0),
                $(this.selectors.addToCartText).text(theme.strings.unavailable),
                $(this.selectors.productPrices)
  //                 .addClass("visibility-hidden")
                  .attr("aria-hidden", "false"));
          }
        },
        _updateImages: function (e) {
          //  console.log('uI variant:', e.variant); 
          var t,
            i = e.variant,
            s = theme.Images.getSizedImageUrl(
              i.featured_image.src,
              this.settings.imageSize
            );
            // console.log("i:", i);
          this.settings.zoomEnabled &&
            (t = theme.Images.getSizedImageUrl(
              i.featured_image.src,
              this.settings.imageZoomSize
            )),
            this._switchImage(s, t),
            this._setActiveThumbnail(s);
        },
        _updatePrice: function (e) {
          var t = e.variant,
            i = theme.Currency.formatMoney(t.price, theme.moneyFormat);
            c = theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat);
            c = c.replace(".00", "");
          (i = i.replace(".00", "")),
            $(this.selectors.originalMobilePrice).html(i),
            $(this.selectors.originalPrice).html(i),
            t.compare_at_price > t.price
              ? ($(this.selectors.comparePrice)
                  .html(c)
                  .removeClass("hide"),
                $(this.selectors.originalPriceWrapper).addClass(
                  this.selectors.saleClasses
                ),
                $(this.selectors.saleLabel).removeClass("hide"))
              : ($(this.selectors.comparePrice).addClass("hide"),
                $(this.selectors.saleLabel).addClass("hide"),
                $(this.selectors.originalPriceWrapper).removeClass(
                  this.selectors.saleClasses
                ));
            $(this.selectors.affirmAsLowAs).attr('data-amount',t.price);
            affirm.ui.refresh();
        },
        _updateQuantityAvailable: function (e) {
          var t = e.variant;
            $(this.selectors.productQuantityAvailable).find('span').html(t.inventory_quantity);
            if(t.inventory_quantity > 0 && t.inventory_quantity < 10 ){
                $(this.selectors.productQuantityAvailable).addClass('show');
            }else {
                $(this.selectors.productQuantityAvailable).removeClass('show');
            }

        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      e
    );
  })()),
  (theme.Quotes = (function () {
    var e = {
        mediaQuerySmall: "screen and (max-width: 749px)",
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        slideCount: 0,
      },
      t = {
        accessibility: !0,
        arrows: !0,
        dots: !1,
        autoplay: !0,
        touchThreshold: 20,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<svg style="fill:#06b9e4;" class="slick-arrow slick-prev lxl4y8-0 ilYzkI zsa45s-3 glHtpl" height="20" viewBox="0 0 11 20" width="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><polygon points="2.9 18.5 1.5 17.1 8.5 10 1.4 2.9 2.8 1.5 11.3 10"></polygon></svg>',
        nextArrow: '<svg style="fill:#06b9e4;" class="slick-arrow slick-next lxl4y8-0 ilYzkI zsa45s-3 glHtpl" height="20" viewBox="0 0 11 20" width="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><polygon points="2.9 18.5 1.5 17.1 8.5 10 1.4 2.9 2.8 1.5 11.3 10"></polygon></svg>'
      };
    function i(i) {
      var s = (this.$container = $(i)).attr("data-section-id"),
        n = (this.wrapper = ".quotes-wrapper"),
        a = (this.slider = "#Quotes-" + s),
        o = $(a, n),
        r = !1,
        c = $.extend({}, t, {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: !0,
        });
      function d(e, t) {
        r && (e.slick("unslick"), (r = !1)), e.slick(t), (r = !0);
      }
      (e.slideCount = o.data("count")),
        e.slideCount < t.slidesToShow &&
          ((t.slidesToShow = e.slideCount), (t.slidesToScroll = e.slideCount)),
        o.on("init", this.a11y.bind(this)),
        enquire.register(e.mediaQuerySmall, {
          match: function () {
            d(o, c);
          },
        }),
        enquire.register(e.mediaQueryMediumUp, {
          match: function () {
            d(o, t);
          },
        });
    }
    return (
      (i.prototype = _.assignIn({}, i.prototype, {
        onUnload: function () {
          enquire.unregister(e.mediaQuerySmall),
            enquire.unregister(e.mediaQueryMediumUp),
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function (e) {
          var t = $(
            ".quotes-slide--" + e.detail.blockId + ":not(.slick-cloned)"
          ).data("slick-index");
          $(this.slider, this.wrapper).slick("slickGoTo", t);
        },
        a11y: function (e, t) {
          var i = t.$list,
            s = $(this.wrapper, this.$container);
          i.removeAttr("aria-live"),
            s.on("focusin", function (e) {
              s.has(e.target).length && i.attr("aria-live", "polite");
            }),
            s.on("focusout", function (e) {
              s.has(e.target).length && i.removeAttr("aria-live");
            });
        },
      })),
      i
    );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = function (e) {
    var t = (this.$container = $(e)).attr("data-section-id"),
      i = (this.slideshow = "#Slideshow-" + t);
    $(".slideshow__video", i).each(function () {
      var e = $(this);
      theme.SlideshowVideo.init(e),
        theme.SlideshowVideo.loadVideo(e.attr("id"));
    }),
      (theme.slideshows[i] = new theme.Slideshow(i));
  }),
  (theme.SlideshowSection.prototype = _.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function () {
        delete theme.slideshows[this.slideshow];
      },
      onBlockSelect: function (e) {
        var t = $(this.slideshow),
          i = $(
            ".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)"
          ).data("slick-index");
        t.slick("slickGoTo", i).slick("slickPause");
      },
      onBlockDeselect: function () {
        $(this.slideshow).slick("slickPlay");
      },
    }
  )),
  $(document).ready(function () {
    var e = new theme.Sections();
    e.register("cart-template", theme.Cart),
      e.register("product", theme.Product),
      e.register("collection-template", theme.Filters),
      e.register("product-template", theme.Product),
      e.register("header-section", theme.HeaderSection),
      e.register("map", theme.Maps),
      e.register("slideshow-section", theme.SlideshowSection),
      e.register("quotes", theme.Quotes);
  }),
  (theme.init = function () {
    theme.customerTemplates.init(),
      slate.rte.wrapTable(),
      slate.rte.iframeReset(),
      slate.a11y.pageLinkFocus($(window.location.hash)),
      $(".in-page-link").on("click", function (e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash));
      }),
      $('a[href="#"]').on("click", function (e) {
        e.preventDefault();
      });
  }),
  $(theme.init);
